import { Box, Container, Heading, Text, VStack, Button } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

export default function CheckoutCancel() {
  return (
    <Box bg="#F7F5EB" color="#0E2721" minH="100vh" py={20}>
      <Container maxW="2xl">
        <VStack spacing={6} textAlign="center">
          <Heading color="#1C4C3F">Order canceled</Heading>
          <Text>No charge was made. You can try again anytime.</Text>
          <Button as={RouterLink} to="/" bg="#1C4C3F" color="white" _hover={{ opacity: 0.9 }}>
            Go to homepage
          </Button>
        </VStack>
      </Container>
    </Box>
  );
}
